import { render, staticRenderFns } from "./PrintDatosGenerales.vue?vue&type=template&id=da1c84b6&"
import script from "./PrintDatosGenerales.vue?vue&type=script&lang=js&"
export * from "./PrintDatosGenerales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports